import { GenIcon } from '../helpers/IconBase.es.js';

const RedirectOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 30", fill: "currentColor", x: "0px", y: "0px" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M14.9849 2C14.4327 2 13.9849 2.44771 13.9849 3C13.9849 3.55228 14.4327 4 14.9849 4L18.5858 4L10.2929 12.2929C9.90237 12.6834 9.90237 13.3166 10.2929 13.7071C10.6834 14.0976 11.3166 14.0976 11.7071 13.7071L20 5.41422L20 9.01503C20 9.56732 20.4477 10.015 21 10.015C21.5523 10.015 22 9.56732 22 9.01504L22 3C22 2.44772 21.5523 2 21 2L14.9849 2Z",
          fill: "black"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M4 8C4 7.44772 4.44772 7 5 7H11.3333C11.8856 7 12.3333 6.55228 12.3333 6C12.3333 5.44772 11.8856 5 11.3333 5H5C3.34315 5 2 6.34315 2 8V19C2 20.6569 3.34315 22 5 22H16C17.6569 22 19 20.6569 19 19V13.2619C19 12.7096 18.5523 12.2619 18 12.2619C17.4477 12.2619 17 12.7096 17 13.2619V19C17 19.5523 16.5523 20 16 20H5C4.44772 20 4 19.5523 4 19V8Z",
          fill: "black"
        }
      },
      {
        tag: "text",
        attr: {
          x: "0",
          y: "39",
          fill: "currentColor",
          fontSize: "5px",
          fontWeight: "bold",
          fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
        },
        child: []
      },
      {
        tag: "text",
        attr: {
          x: "0",
          y: "44",
          fill: "currentColor",
          fontSize: "5px",
          fontWeight: "bold",
          fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
        },
        child: []
      }
    ]
  })(props);
};

export { RedirectOutlined };
